const deps = [require('ui/web/documentCard').name];

module.exports = angular
  .module('bench.app.dms.addons.addon', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.addons.addon', {
      url: '/:date/addon/{addOnId:[0-9]*}',
      params: {
        date: {
          value: String(new Date().getFullYear()),
        },
      },
      controller($stateParams, $state) {
        if ($stateParams.date === 'all') {
          $state.go('bench.dms.addons.addon', angular.extend($stateParams, { date: '' }));
        }
        this.$stateParams = $stateParams;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<bl-document-card
  month="vm.$stateParams.month"
  date="vm.$stateParams.date"
  client-id="vm.$stateParams.clientId"
  document-type="ADD_ON"
  add-on-id="vm.$stateParams.addOnId"
  >
</bl-document-card>\
`,
    }),
  );
